import { CircularProgress } from "@mui/material";
import React from "react";
import { toast } from "react-toastify";
import { AuthContext } from "../../../context/auth/ApiContext";
import { ThemeContext } from "../../../context/theme/ThemeContext";
import { DashBar, StudentSideMenu } from "../../../layout/Dashboard";
import { errorMessage, successMessage } from "../../../utils/notification";
import { authGetRequest, authPostRequest } from "../../../api/laravel/public/api";
import Style from "./profile.module.scss";
import { Company, Footer, MenuBar } from "../../../layout/welcome";
import { HeaderText, ModalLayout, TextEditor } from "../../../components";
import { Link, useHistory } from "react-router-dom";
import { Home } from "@mui/icons-material";
import { _retrieveData } from "../../../utils/local-storage";
import { ProfileUpdateNotification } from "../../../layout/Notifications";
import femaleJpg from "../../../asset/female.png";
import maleJpg from "../../../asset/male.png";
import { settingContext } from "../../../context/Setting/Setting";

function Profile() {
  const { theme, changeTheme } = React.useContext(ThemeContext);
  const { changeAuthUser } = React.useContext(AuthContext);
  const [user, setUser] = React.useState(null);
  const [isLoading, setLoading] = React.useState(false);
  const [input, setInput] = React.useState({});
  const [isPageLoader, setPageLoader] = React.useState(false);
  const [event, setEvent] = React.useState({});
  const [inbox, setInbox] = React.useState({});
  const [data, setData] = React.useState({});
  const { page } = React.useContext(settingContext);
  const history = useHistory();

  const handleInputs = (label, e) => {
    var val = e.target.value;
    setInput({ ...input, [label]: val });
  };

  React.useEffect(() => {
    checkUser();
    dashboardGet();
  }, []);

  const checkUser = async () => {
    setPageLoader(true);
    const { data_r, isLoading, isError } = await authGetRequest("/account/profile");
    setPageLoader(false);
    if (isError) {
      let userData = await _retrieveData('user_info');
      if (!userData) {
        setUser(null);
      }
      else {
        setInput(userData);
      }
    }
    setInput(data_r);
  }

  React.useEffect((e) => {
    eventsGet();
    getInbox();
  }, []);

  const eventsGet = async (e) => {
    // setPageLoader(true);
    const { data_r, isError } = await authGetRequest(`/account/events`);
    if (isError) {
      // errorMessage(toast, data_r?.message);
      setPageLoader(false);
      return false;
    }
    setEvent(data_r);
    // setPageLoader(false);
  };

  const getInbox = async () => {
    let resp = await authGetRequest(`/account/inbox`);
    setInbox(resp.data_r);
  };

  const submitProfile = async (event) => {
    event.preventDefault();
    setLoading(true);
    input["device_name"] = navigator.userAgent;
    const { data_r, isLoading, isError } = await authPostRequest(
      "/account/update",
      input
    );
    if (isError) {
      errorMessage(toast, data_r.message);
    } else {
      changeAuthUser(data_r);
      checkUser();
      successMessage(toast, "Information updated successfully");
    }
    setLoading(false);
  };

  const onChangeHandler = async (e) => {
    const file = e.target.files[0];
    if (file.size > 1000024) {
      errorMessage(toast, "File size cannot exceed more than 1MB");
      return false;
    } else {
      const formData = new FormData();
      formData.append("image", file);
      const { data_r, isLoading, isError } = await authPostRequest(
        "/account/update/image",
        formData
      );
      if (isError) {
        errorMessage(toast, data_r.message);
      } else {
        changeAuthUser(data_r);
        checkUser();
        successMessage(toast, "Information updated successfully");
      }
      setLoading(false);
    }
  };

  const dashboardGet = async () => {
    setPageLoader(true);
    const { data_r, isError } = await authGetRequest(`/account/dashboard`);
    if (isError) {
      // errorMessage(toast, data_r?.message);
      setPageLoader(false);
      return false;
    }
    setData(data_r);
    setPageLoader(false);
  };

  return (
    <div id="page-top" class="home">
      <div id="page-wrap">
        <MenuBar event={event} inbox={inbox} menuIndex="auth" setting={page?.setting} loader={isPageLoader} />
        <section className="profile-feature">
          <div className="awe-parallax bg-profile-feature" style={{ backgroundImage: 'url(../img/bg.jpg)' }} />
          <div className="awe-overlay overlay-color-3" />
          <div className="container">
            <div className="info-author">
              <div className="image">
                <img src={input?.image ? process.env.REACT_APP_LOCAL_FILE_PATH + "profile/medium/" + input?.image : input?.gender === "male" ? '/static/media/male.png' : '/static/media/female.png'} alt="" />
              </div>
              <div className="name-author">
                <h2 className="big">{input?.first_name} {input?.last_name}</h2>
              </div>
              <div className="address-author">
                <i className="fa fa-map-marker" />
                <h3>{input?.country}</h3>
              </div>
            </div>
            <div className="info-follow">
              <div className="trophies">
                <span>{data?.cert_count}</span>
                <p>Certificates</p>
              </div>
              <div className="trophies">
                <span>{data?.count_course}</span>
                <p>Courses</p>
              </div>
              <div className="trophies">
                <span>{data?.count_active_course}</span>
                <p>Active Course</p>
              </div>
              <div className="trophies">
                <span>{data?.complete_course}</span>
                <p>Completed Course</p>
              </div>
            </div>
          </div>
        </section>

        <section className="content-bar">
          <div className="container">
            <ul style={{ width: '100%' }}>
              <li >
                <Link to="/student/home">
                  <i className="icon mdi mdi-book-open" />
                  Learning
                </Link>
              </li>
              <li>
                <Link to="/student/courses">
                  <i className="icon mdi mdi-note" />
                  Courses
                </Link>
              </li>
              <li>
                <Link to="/student/calendar">
                  <i className="icon mdi mdi-calendar" />
                  Events
                </Link>
              </li>
              {/* <li>
              <a href="account-assignment.html">
                <i className="icon mdi mdi-note" />
                Assignment
              </a>
            </li> */}
              <li className="current">
                <Link to="/student/profile">
                  <i className="icon mdi mdi-account" />
                  Profile
                </Link>
              </li>
              <li>
                <Link to="/student/inbox">
                  <i className="icon mdi mdi-gmail" />
                  Inbox
                </Link>
              </li>
            </ul>
          </div>
        </section>
        <section className="profile">
          <div className="container">
            <h3 className="md black">Profile</h3>
            <div className="row">
              <div className="col-md-9">
                <div className="avatar-acount">
                  <div className="changes-avatar">
                    <div className="img-acount">
                      <img src={input?.image ? process.env.REACT_APP_LOCAL_FILE_PATH + 'profile/small/' + input?.image : input?.gender === "male" ? '/static/media/male.png' : '/static/media/female.png'} alt="" />
                    </div>
                    <div className="choses-file up-file">
                      <input type="file" id="upload"
                        onChange={onChangeHandler}
                        className="account-file-input"
                        hidden
                        accept="image/png, image/jpeg" />
                      <input type="hidden" />
                      <a href className="mc-btn btn-style-6">Change image</a>
                    </div>
                  </div>
                  <div className="info-acount">
                    <h3 className="md black">{input?.first_name} {input?.last_name}</h3>
                    <p>{input?.description}</p>
                    <div className="security">
                      <form
                        method="POST"
                        onSubmit={submitProfile}
                        enctype="multipart/form-data"
                        className="my-4"
                      >
                        <div className="row">
                          <div className="col-md-4 col-full">
                            <div className="form-group mb-3">
                              <label
                                className="black"
                                for="first_name"
                              >
                                First Name <em className="text-red-500">(Required)</em>
                              </label>
                              <input
                                value={input?.first_name}
                                type="text"
                                className="form-control"
                                onChange={(e) => handleInputs("first_name", e)}
                                name="first_name"
                                id="first_name"
                                placeholder="First Name"
                              />
                            </div>
                          </div>
                          <div className="col-md-4 col-full">
                            <div className="form-group mb-3">
                              <label
                                className="black"
                                for="middle_name"
                              >
                                Middle Name 
                              </label>
                              <input
                                value={input?.middle_name}
                                type="text"
                                className="form-control"
                                onChange={(e) => handleInputs("middle_name", e)}
                                name="middle_name"
                                id="middle_name"
                                placeholder="Middle Name"
                              />
                            </div>
                          </div>
                          <div className="col-md-4 col-full">
                            <div className="form-group mb-3">
                              <label
                                className="black"
                                for="last_name"
                              >
                                Last Name <em className="text-red-500">(Required)</em>
                              </label>
                              <input
                                value={input?.last_name}
                                type="text"
                                className="form-control"
                                onChange={(e) => handleInputs("last_name", e)}
                                name="last_name"
                                id="last_name"
                                placeholder="Last Name"
                              />
                            </div>
                          </div>
                          <div className="col-md-4 col-full">
                            <div className="mb-3">
                              <label
                                className="black"
                                for="basic-default-fullname"
                              >
                                Gender <em className="text-red-500">(Required)</em>
                              </label>
                              <select
                                name="gender"
                                onChange={(e) => handleInputs("gender", e)}
                                className="form-control"
                              >
                                <option
                                  value=""
                                >
                                  Choose Gender
                                </option>
                                <option
                                  selected={
                                    input?.gender === "male" ? true : false
                                  }
                                  value="male"
                                >
                                  Male
                                </option>
                                <option
                                  selected={
                                    input?.gender === "female" ? true : false
                                  }
                                  value="female"
                                >
                                  Female
                                </option>
                              </select>
                            </div>
                          </div>
                          <div className="col-md-4 col-full">
                            <div className="mb-3">
                              <label
                                className="black"
                                for="phone_number"
                              >
                                Phone Number <em className="text-red-500">(Required)</em>
                              </label>
                              <input
                                value={input?.phone}
                                type="text"
                                className="form-control"
                                onChange={(e) => handleInputs("phone", e)}
                                name="phone"
                                id="phone_number"
                                placeholder="Phone Number"
                              />
                            </div>
                          </div>
                          <div className="col-md-4 col-full">
                            <div className="mb-3">
                              <label
                                className="black"
                                for="country"
                              >
                                State & Country <em className="text-red-500">(Required)</em>
                              </label>
                              <input
                                value={input?.country}
                                type="text"
                                onChange={(e) => handleInputs("country", e)}
                                className="form-control"
                                name="country"
                                id="country"
                                placeholder="e.g Lagos, Nigeria"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-4 col-full">
                            <div className="mb-3">
                              <label
                                className="black"
                                for="password"
                              >
                                Password (Leave empty if you are not changing)
                              </label>
                              <input
                                type="password"
                                className="form-control"
                                value={""}
                                onChange={(e) => handleInputs("password", e)}
                                name="password"
                                id="password"
                                placeholder="Password"
                              />
                            </div>
                          </div>
                          <div className="col-md-4 col-full">
                            <div className="mb-3">
                              <label
                                className="black"
                                for="repassword"
                              >
                                Confirm Password (Leave empty if you are not
                                changing)
                              </label>
                              <input
                                type="password"
                                className="form-control"
                                value={""}
                                name="repassword"
                                onChange={(e) => handleInputs("repassword", e)}
                                id="repassword"
                                placeholder="Confirm Password"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="mb-3">
                          <label
                            className="black"
                            for="basic-default-company"
                          >
                            Biography & Achievements
                          </label>
                          {/* <div
                           dangerouslySetInnerHTML={{ __html: input?.description }}
                         /> */}

                          <textarea
                            className="form-control"
                            onChange={(e) => handleInputs("description", e)}
                            name="description"
                            // value={[input?.description]}
                            placeholder="Full explanation what the content is meant to achieve"
                          >


                            {/* {input?.description} */}
                          </textarea>
                        </div>
                        {/* <div className="row">
                          <div className="col-md-4 col-full">
                            <div className="mb-3">
                              <label
                                className="black"
                                for="portfolio"
                              >
                                Portfolio Website
                              </label>
                              <input
                                value={input?.website}
                                type="text"
                                className="form-control"
                                onChange={(e) => handleInputs("website", e)}
                                name="website"
                                id="portfolio"
                                placeholder="Official Website"
                              />
                            </div>
                          </div>
                          <div className="col-md-4 col-full">
                            <div className="mb-3">
                              <label
                                className="black"
                                for="linkedin"
                              >
                                Linkedin Url
                              </label>
                              <input
                                value={input?.linkedin}
                                type="text"
                                className="form-control"
                                onChange={(e) => handleInputs("linkedin", e)}
                                name="linkedin"
                                id="linkedin"
                                placeholder="Linkedin Url"
                              />
                            </div>
                          </div>
                          <div className="col-md-4 col-full">
                            <div className="mb-3">
                              <label
                                className="black"
                                for="twitter"
                              >
                                Twitter Url
                              </label>
                              <input
                                value={input?.twitter}
                                type="text"
                                className="form-control"
                                onChange={(e) => handleInputs("twitter", e)}
                                name="twitter"
                                id="twitter"
                                placeholder="Twitter Url"
                              />
                            </div>
                          </div>
                          <div className="col-md-4 col-full">
                            <div className="mb-3">
                              <label
                                className="black"
                                for="facebook"
                              >
                                Facebook Url
                              </label>
                              <input
                                value={input?.facebook}
                                type="text"
                                className="form-control"
                                onChange={(e) => handleInputs("facebook", e)}
                                name="facebook"
                                id="facebook"
                                placeholder="Facebook Url"
                              />
                            </div>
                          </div>
                          <div className="col-md-4 col-full">
                            <div className="mb-3">
                              <label
                                className="black"
                                for="instagram"
                              >
                                Instagram Url
                              </label>
                              <input
                                value={input?.instagram}
                                type="text"
                                className="form-control"
                                onChange={(e) => handleInputs("instagram", e)}
                                name="instagram"
                                id="instagram"
                                placeholder="Instagram Url"
                              />
                            </div>
                          </div>

                        </div> */}
                        <div className="input-save">
                          <input type="submit" defaultValue="Save changes" className="mc-btn btn-style-1" />
                        </div>
                      </form>
                    </div>
                  </div>

                </div>
              </div>
              <div className="col-md-3 col-full">
                {/* <div className="social-connect">
                  <h5>Social connect</h5>
                  <ul>
                    <li>
                      <a href={input?.twitter} className="twitter">
                        <i className="icon mdi mdi-twitter" />
                        <p>{input?.twitter}</p>
                      </a>
                    </li>
                    <li>
                      <a href={input?.facebook} className="facebook">
                        <i className="icon mdi mdi-facebook" />
                        <p>{input?.facebook}</p>
                      </a>
                    </li>
                    <li>
                      <a href={input?.instagram} className="gg-plus">
                        <i className="icon mdi mdi-instagram" />
                        <p>{input?.instagram}</p>
                      </a>
                    </li>
                    <li>
                      <a href={input?.linkedin} className="facebook">
                        <i className="icon mdi mdi-linkedin" />
                        <p>{input?.linkedin}</p>
                      </a>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
          </div>
        </section>
        <Footer setting={page?.setting} />
      </div>
    </div>
  );
};

export default Profile;
